import { apiGet, apiPut } from '@/lib/api';
import { UserResponse, ChangePasswordRequest, UserNotificationPreferences } from '@troia-v3/types';

export interface UpdateProfileRequest {
  firstName?: string;
  lastName?: string;
  phone?: string;
  avatar?: string;
  timezone?: string;
  language?: string;
}

/**
 * Account API Service
 * Handles user profile and account management
 */
export const accountApi = {
  /**
   * Get current authenticated user profile
   */
  async getCurrentUser(signal?: AbortSignal): Promise<UserResponse> {
    return apiGet<UserResponse>('/users/me', { signal });
  },

  /**
   * Update current user profile (limited fields)
   */
  async updateProfile(data: UpdateProfileRequest, signal?: AbortSignal): Promise<UserResponse> {
    return apiPut<UserResponse>('/users/me', data, { signal });
  },

  /**
   * Update current user password
   */
  async updatePassword(data: ChangePasswordRequest, signal?: AbortSignal): Promise<void> {
    return apiPut<void>('/users/profile/password', data, { signal });
  },

  /**
   * Update user notification preferences
   */
  async updateNotificationPreferences(preferences: UserNotificationPreferences, signal?: AbortSignal): Promise<UserResponse> {
    return apiPut<UserResponse>('/users/me/notification-preferences', preferences, { signal });
  },
};
